import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Heading5 } from '../../widgets';
import Permission from '../Common/Permission';
import { getUserPermission, enableUserPermission } from '../../../actions/users';

const PermissionFormModal = (props) => {
    const { onHide, userId, userInfo, actions } = props;
    const isRequesting = userInfo.isRequestingPermission ? userInfo.isRequestingPermission : false;

    useEffect(() => {
        !userInfo.permission && actions.getUserPermission(userId);
    }, []);

    const updateUserPermission = (params, cb) => {
        actions.enableUserPermission({ ...params, user_id: userId }, cb);
    }

    return <Modal className="permission-form-modal" show={true} backdrop="static" onHide={onHide} size='md'>
        <Modal.Header closeButton style={{ color: '#064d9e', border: 0 }}>
            <Modal.Title className="ml-2">
                <Heading5>
                    Permission
            </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Permission
                id={userId}
                isRequesting={isRequesting}
                permissionInfo={userInfo.permission}
                updatePermission={updateUserPermission} />
        </Modal.Body>
    </Modal>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getUserPermission, enableUserPermission }, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
    userInfo: state.users.userListById.payload[ownProps.userId]
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionFormModal);
